import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import axios from "axios";
import Cookies from 'js-cookie';
import {useDispatch} from "react-redux";
// Assume there's a backend API endpoint for checking login status


const checkLoginStatusAPI = '/api/check-login-status';


// Action to set user ID in the cookie
export const setUserIdInCookie = (userId) => {
    Cookies.set('guid', userId);
};

// Action to get user ID from the cookie
export const getUserIdFromCookie = () => {
    return Cookies.get('guid');
};

const initialState = {
    isLoggedIn: false,
    name: '',
    family: '',
    userid: null,
    coin: null,
    grade: null,
    InsPay: null,
    regdate: ''
};

const authSlice = createSlice({
    name: "user",
    initialState: initialState,
    reducers: {
        login: (state, action) => {
            state.isLoggedIn = true;
            state.name = action.payload.name;
            state.family = action.payload.family;
            state.userid = action.payload.userid;
            state.coin = action.payload.coin;
            state.grade = action.payload.grade;
            state.InsPay = action.payload.InsPay;
            state.regdate = action.payload.regdate;
            // Cookies.set('guid', response.msg, { expires: 365 })
        },
        logoutStatic: (state) => {
            state.isLoggedIn = false;
            state.name = '';
            state.family = '';
            state.userid = null;
            state.coin = null;
            state.grade = null;
            state.InsPay = null;
            state.regdate = ''
            Cookies.remove("guid");
        },
    },
});

export const {login, logoutStatic} = authSlice.actions;
export default authSlice.reducer;